import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { EMessageType } from 'src/app/shared/data/response-default.interface';
import { ToastService } from 'src/app/shared/services/toast.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.scss']
})
export class RecoverPasswordComponent {
  recoverPasswordForm: UntypedFormGroup;
  showModal = false;
  email: string = '';

  constructor(
    private readonly fb: UntypedFormBuilder,
    private readonly authService: AuthService,
    private readonly toastService: ToastService
  ) {
    this.recoverPasswordForm = this.fb.group({
      email: [null, [Validators.required, Validators.email]],
    });
  }

  recover(): void {
    if(this.recoverPasswordForm.invalid){
      this.recoverPasswordForm.markAllAsTouched();
      this.toastService.toast('Campo e-mail é obrigatório.', EMessageType.Error);
      return;
    }

    const { email } = this.recoverPasswordForm.getRawValue();
    this.email = email;
    
    this.authService.forgotPassword(email).subscribe(() => this.showModal = true);
  }
}
